import salesOrderLinesServiceGen from "./generated/salesOrderLinesServiceGen";
import { getCore as get, postCore as post } from "../../utils/httpInterceptor";

class salesOrderLinesService extends salesOrderLinesServiceGen {
  static async materialAlternatives(id) {
    const idPath = salesOrderLinesServiceGen.buildIdPath(id);
    return await get(`${salesOrderLinesServiceGen.getApiPath("sales-order-lines")}/${idPath}/material-alternatives`);
  }

  static async changeMaterial(id, itemId) {
    const idPath = salesOrderLinesServiceGen.buildIdPath(id);
    return await post(`${salesOrderLinesServiceGen.getApiPath("sales-order-lines")}/${idPath}/change-material`, { itemId });
  }

  static async addMaterialLine(id, itemId) {
    const idPath = salesOrderLinesServiceGen.buildIdPath(id);
    return await post(`${salesOrderLinesServiceGen.getApiPath("sales-order-lines")}/${idPath}/add-material-line`, { itemId });
  }

  static async createPlaceholderItem(id, material = {}) {
    const idPath = salesOrderLinesServiceGen.buildIdPath(id);
    return await post(`${salesOrderLinesServiceGen.getApiPath("sales-order-lines")}/${idPath}/create-placeholder-item`, material);
  }

  static async resolvePlaceholderItem(id, itemId) {
    const idPath = salesOrderLinesServiceGen.buildIdPath(id);
    return await post(`${salesOrderLinesServiceGen.getApiPath("sales-order-lines")}/${idPath}/resolve-placeholder-item`, { itemId });
  }

  static async getAll(page = 0, pageSize = 100, sort = [], filters = {}) {
    const result = await super.getAll(page, pageSize, sort, filters);
    const rows = Array.isArray(result?.content) ? result.content : [];
    const enriched = await Promise.all(rows.map(async (row) => {
      try {
        const alternatives = await this.materialAlternatives(row.id || row);
        const count = Array.isArray(alternatives)
          ? alternatives.filter((candidate) => !candidate.currentItem).length
          : 0;
        return {
          ...row,
          materialAlternatives: alternatives || [],
          materialAlternativeCount: count,
        };
      } catch (error) {
        return {
          ...row,
          materialAlternatives: [],
          materialAlternativeCount: 0,
        };
      }
    }));
    return {
      ...result,
      content: enriched,
    };
  }
}

export default salesOrderLinesService;
